export default __webpack_public_path__ + "static/media/3013.74ac45b4.jpg";